/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.majApp.ts
 *
 * Version de l'application et bouton « Vérifier les mises à jour » de la
 * page « Plus » (2026-10-07, demande de Mika : « "Recharger" ne vient jamais
 * sur mon iPhone »). Fusionné dans fr.ts. Mikael - chef de projet - 2026-10-07
 */
export const messagesMajAppFr: Record<string, string> = {
  'majApp.titre': 'Version de l’application',
  'majApp.version': 'Version de l’application : {version}',
  'majApp.versionInconnue': 'inconnue',
  'majApp.verifier': 'Vérifier les mises à jour',
  'majApp.verificationEnCours': 'Vérification…',
  'majApp.aJour': 'Vous avez la dernière version.',
  'majApp.miseAJour': 'Nouvelle version trouvée : l’application se met à jour…',
  'majApp.injoignable': 'Vérification impossible : pas de réseau. Réessayez plus tard.',
};
